function init() {
  const copyElements = document.querySelectorAll(".copyValue");

  copyElements.forEach(el => {
    el.addEventListener("click", () => handleCopyClick(el));
  });
}

// クリック時にクリップボードにコピーして「Copy!」表示する関数
async function handleCopyClick(el) {
  const textToCopy = el.getAttribute("data-clipboard-text");
  try {
    await navigator.clipboard.writeText(textToCopy);
    const originalText = el.textContent;
    el.textContent = "Copied!";
    setTimeout(() => {
      el.textContent = originalText;
    }, 1500);
  } catch (err) {
    console.error("コピーに失敗しました:", err);
  }
}

export default {
  init,
};
